export const SET_INDICATIONREWARD = 'INDICATIONREWARD/SET_INDICATIONREWARD'
export const SET_INDICATIONREWARDS = 'INDICATIONREWARD/SET_INDICATIONREWARDS'
